import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { type UserToChat, isUserToChat } from 'features/chat';

type CreateChatLocationState = {
  userToChat?: unknown;
};

export const useCreateChatUserFromLocation = (): { userToChat: undefined | UserToChat } => {
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- useLocation returns state as any
  const state: CreateChatLocationState | undefined = location.state;

  const userToChat = state?.userToChat;

  return useMemo(
    () => ({
      userToChat: isUserToChat(userToChat) ? userToChat : undefined,
    }),
    [userToChat],
  );
};
